import { IScreen } from "Core/Screens/IScreen";
import {Event} from 'Core/Common/Event';
import {PUB_SUB_EVENTS} from 'MenuManager/PubSubEvents';
import { controlFacade } from "./ControlFacade";
import { EVENTS } from "Core/Screens/Events";
export interface INavigateToScreenOptions {
    entityId: number;
    recordId: number;
}

export const screenFacade = (screen: IScreen) => {

    const addOnClose = (handler: Function) =>{
        screen.On(EVENTS.MODAL_CLOSE, this, ()=> handler.apply(null));
    }

    const addOnAfterSave = (handler: Function) =>{
        screen.On('RECORD_SAVED', this, async (evtArgs)=> {
            await handler({ recordId: evtArgs.data.RecordId });
        });
    }

    const getAllControls = () =>{
        return _.map(screen.GetAllControls(), (control)=> controlFacade(control));
    }

    const showInModal = () =>{
        screen.ShowInModal();                    
    }

    const navigateToScreen = (options: INavigateToScreenOptions) =>{
        PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, {
            EntityId: options.entityId,
            RecordId: options.recordId
        });
    }

    return { addOnAfterSave, getAllControls, navigateToScreen, showInModal, addOnClose }
}